<template>
  <modal @before-open="beforeOpen" @opened="opened" name="notice" :draggable="'.header'" :reset="true"
         :classes="['todobox','generalbox']" :adaptive="true"
         :height="'80%'" :width="'80%'" :max-width="1540" :max-height="885" :min-width="1092"
         :min-height="614" :click-to-close="false">
    <div @click="close" class="close">
      <i class="iconfont icon-cha"></i>
    </div>
    <div class="header">
      <h2>通知公告
        <button v-if="userInfo.extend && userInfo.extend.tzggAdmin" @click="createNotice"
                class="createNotice">发布
        </button>
      </h2>
    </div>
    <div class="content">
      <div class="searchArea">
        <button @click="reset" class="reset">重置</button>
        <div class="search">
          <input v-model="keyword" @keypress.13="requestNoticeList" type="text"/>
          <button @click="requestNoticeList(1)"><i class="iconfont icon-ai219"></i></button>
        </div>

        <multiselect v-model="sendTarget"
                     :options="sendTargetList"
                     placeholder="请选择发送目标"
                     label="name"
                     :multiple="false"
                     :show-labels="false"
                     :clear-on-select="false"
                     :close-on-select="true"
                     :allow-empty="true"
                     :taggable="true"
                     @select="selectSendTarget"
        ></multiselect>

        <multiselect v-model="appName"
                     :options="filterSystemList"
                     placeholder="请选择系统名称"
                     label="dictLabel"
                     :multiple="false"
                     :show-labels="false"
                     :clear-on-select="false"
                     :close-on-select="true"
                     :allow-empty="true"
                     :taggable="true"
                     @select="selectApp"
        ></multiselect>
        <multiselect v-model="currSortSort"
                     :options="noticeSortList"
                     placeholder="请选择系统名称"
                     label="name"
                     :multiple="false"
                     :show-labels="false"
                     :clear-on-select="false"
                     :close-on-select="true"
                     :allow-empty="true"
                     :taggable="true"
                     @select="selectNoticeSort"
        ></multiselect>

      </div>
      <ul class="noticeList">
        <li @click="openDetail(noticeItem,$event)" v-for="noticeItem in noticeList">
          <div>
            {{noticeItem.time | convertTimeToDate}}
          </div>
          <h2>
            <i v-if="noticeItem.top" class="inTop iconfont icon-top01"></i>
            <i v-if="noticeItem.sysId==='ehall' && noticeItem.state===0" class="edit iconfont icon-caogao"></i>
            <i v-if="noticeItem.state===2" class="verify iconfont icon-shenhezhong2"></i>
            <i v-if="noticeItem.state===3" class="reject iconfont icon-zhuangtaiyibohui"></i>
            {{noticeItem.title}}
          </h2>
          <p>来自:{{noticeItem.sysName}} &nbsp;&nbsp;阅读{{noticeItem.readNum ? noticeItem.readNum : '1'}}次</p>
          <ul class="btnlist">
            <li v-if="userInfo.tzggAdmin" @click.stop="toTopHandle(noticeItem)">{{noticeItem.top ? '取消置顶' : '置顶'}}
            </li>
            <li v-if="noticeItem.sysId==='ehall' && noticeItem.userid===userInfo.loginName"
                @click.stop="revokeNotice(noticeItem,2)">删除
            </li>
            <li v-if="noticeItem.sysId==='ehall' && noticeItem.userid===userInfo.loginName && noticeItem.state===1"
                @click.stop="revokeNotice(noticeItem,0)">撤回
            </li>

          </ul>
        </li>
      </ul>
      <div class="pagination">
        <v-pagination @page-change="pageChange" @page-size-change="pageSizeChange" :total="totalCount"
                      :pageIndex="pageNumber" :page-size="pageSize" :pageSizeOption="[10,20,30]"></v-pagination>
      </div>
    </div>
  </modal>
</template>

<script>
  import axios from 'axios';
  import apiConfig from 'common/js/api_config';
  import {mapState, mapGetters, mapMutations} from 'vuex';
  import multiselect from 'vue-multiselect';
  //通信总线
  import Bus from 'common/js/bus.js';

  export default {
    name: "notice",
    data() {
      return {
        appName: null,
        noticeList: [],
        //-----分页相关-------
        totalCount: null,
        pageNumber: 1,
        pageSize: 10,
        pageCount: null,

        //--------筛选条件---------
        property: "title",
        keyword: null,

        selectOptions: ["教务", "学工", "OA"],

        sendTarget: null,
        sendTargetList: [
          {
            name: '全部',
            value: -1
          },
          {
            name: '发送至公共',
            value: 0
          },
          {
            name: '发送至部门',
            value: 1
          },
          {
            name: '发送至人员',
            value: 2
          },
          {
            name: '发送至标签组',
            value: 3
          },

        ],

        currSortId: null,
        currSortSort: null,
        noticeSortList: [],

        filterSystemList: []
      }
    },
    methods: {
      ...mapMutations(['updateNoticeList', 'updateModalZIndex']),
      close() {
        this.$modal.hide("notice");
      },
      pageChange(pageIndex) {
        this.pageNumber = pageIndex;
        this.requestNoticeList();
      },
      pageSizeChange(newPageSize) {
        this.pageSize = newPageSize;
        this.requestNoticeList();
      },
      //请求通知列表
      async requestNoticeList(type) {
        if (type) {
          this.pageNumber = 1
        }
        console.log("%c正在请求通知公告列表...", "font-size:20px;color:#007d77")
        let noticeList = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getNoticeList?" + this.$qs.stringify({
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
          property: this.property,
          title: this.keyword,
          sysId: this.appName ? this.appName.dictId : null,
          type: this.sendTarget ? this.sendTarget.value : -1,
          noticeSort: this.currSortId
        }));
        noticeList = noticeList.data;
        console.log(noticeList)
        if (noticeList.status === 1) {
          this.noticeList = noticeList.data[0].list;
          this.pageNumber = noticeList.data[0].pageNumber;
          this.pageCount = noticeList.data[0].pageCount;
          this.totalCount = noticeList.data[0].totalCount;
          if (this.pageNumber === 1) {
            this.$store.commit("updateNoticeList", this.noticeList);
          }
        }
        // console.log("通知公告列表：", noticeList.data[0].list)
      },
      selectApp() {
        this.$nextTick(() => {
          this.requestNoticeList()
        })

      },
      //选择发送目标
      selectSendTarget() {
        this.$nextTick(() => {
          this.requestNoticeList()
        })
      },
      reset() {
        this.appName = null;
        this.keyword = null;
        this.currSortSort = null;
        this.currSortId = null;
        this.sendTarget = null;
        this.requestNoticeList();
      },
      openDetail(data) {
        let url = data.url;
        let title = data.title;
        if (data.sysId === 'ehall' && data.state === 0) {
          this.$modal.show("createNotice", {data, url, title});
        } else {
          if(data.appOpenType=='window'){
            window.open(url)
          }else{
            this.$modal.show("noticeDetail", {data, url, title});
          }
        }
      },
      beforeOpen(data) {
        if (data.params && data.params.type) {
          this.currSortId = data.params.sortId
        } else {
          this.currSortId = null
          this.currSortSort = null
        }
        this.requestNoticeList();
      },
      opened() {
        this.initNoticeSort()
        this.updateModalZIndex(this.$el)
      },
      createNotice() {
        this.$modal.show("createNotice", {});
      },

      //撤回/删除通知公告
      revokeNotice(notice, handleId) {
        //handleId:2 删除 0 撤回 1 发布
        let operateType = ''
        switch (handleId) {
          case 0:
            operateType = '撤回'
            break;
          case 2:
            operateType = '删除'
        }
        this.$confirm(`确认${operateType}本条通知公告？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let handleResult = await axios.post(apiConfig.REQUEST_URL + "/shall/front_updateNotice?" + this.$qs.stringify({
            id: notice.id,
            state: handleId
          }));
          this.$notify({
            group: 'global',
            title: '温馨提示',
            text: handleResult.data.msg,
          });
          Bus.$emit("noticeChange", {});
        }).catch(() => {

        });
      },
      //置顶操作
      async toTopHandle(notice) {
        let toTopResp = await axios.post(apiConfig.REQUEST_URL + '/shall/front_updateNoticeTop?' + this.$qs.stringify({
          id: notice.id,
          top: notice.top ? 0 : 1
        }))
        this.$notify({
          group: 'global',
          title: '温馨提示',
          text: toTopResp.data.msg,
        });
        Bus.$emit("noticeChange", {});
      },
      showSchedule() {
        // this.close()
        this.$modal.show('schedule')
      },
      //获取可筛选的系统列表
      async fetchFilterSystemList() {
        let sysList = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getDictEntry?' + this.$qs.stringify({
          title: 'FROM_SYSTEM_NOTICE',
          type: 1,
          childNode: 1
        }))
        if (!sysList.data.status) {
          return
        }
        this.filterSystemList = sysList.data.data
      },
      //获取审核行号
      getRowNum(rowData, rowIndex, pagingIndex, field) {
        return this.pageSize * (this.pageIndex - 1) + (rowIndex + 1);
      },
      async initNoticeSort() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_getNoticeColumnList')
        if (resp.data.status !== 1) {
          return
        }
        resp.data.data.forEach(item => {
          item.name = item.columnName
          item.value = item.noticeSort
        })
        this.noticeSortList = resp.data.data
        if (this.currSortId) {
          for (let i = 0; i < this.noticeSortList.length; i++) {
            if (this.noticeSortList[i].noticeSort === this.currSortId) {
              this.currSortSort = this.noticeSortList[i]
            }
          }
        }
      },
      selectNoticeSort() {
        this.$nextTick(() => {
          if (!this.currSortSort) {
            return
          }
          this.currSortId = this.currSortSort.noticeSort
          this.requestNoticeList()
        })
      }
    },
    computed: {
      ...mapState(['systemList', 'userInfo']),
    },
    watch: {
      sendTarget(newVal) {
        if (!newVal) return
        if (newVal.value === -1) {
          this.sendTarget = null
        }
      },
      appName(newVal) {
        if (!newVal) return
        if (newVal.dictId === '') {
          this.appName = null
        }
      }
    },
    mounted() {
      this.fetchFilterSystemList()
      Bus.$on("noticeChange", () => {
        this.requestNoticeList();
      })
    },
    filters: {
      convertTimeToDate(val) {
        if (val) {
          return val.split(" ")[0]
        }
      }
    },
    components: {multiselect}
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .header
    h2
      .createNotice
        outline none
        background none
        padding 0 10px
        font-size 14px
        border 1px solid #cccccc
        margin-left 10px
        border-radius 5px
        transition 300ms

        &:hover
          background-color #eeeeee

  .content
    .navList
    .searchArea
      margin-top 16px
      border-bottom 1px solid #eeeeee
      position relative
      height 35px

      & > .reset
        border 1px solid #cccccc
        float right
        width 100px
        height 26px
        border-radius 5px
        background-color #ffffff
        color #666666
        font-size 12px
        margin-right 20px
        outline none
        transition 300ms
        user-select none

        &:hover
          background-color #eeeeee

      & >>> div.multiselect
        width 150px
        height 26px
        line-height 25px
        border-radius 5px
        border 1px solid #cccccc
        float right
        margin-right 20px

        .multiselect__single, .multiselect__placeholder
          position relative
          top -3px

      .search
        width 300px
        height 26px
        border-radius 5px
        overflow hidden
        border 1px solid #cccccc
        position relative
        margin-right 20px
        float right

        button
          background-color #eeeeee
          border none
          outline none
          width 50px
          height 26px
          position absolute
          right 0
          top 0

          i
            color #333333

        input
          width 260px
          line-height 26px
          padding-left 10px
          font-size 12px
          color #666666

    .noticeList
      margin-top 10px
      padding-right 10px

      li
        border-bottom 1px solid #eeeeee
        height 70px

        & > div
          overflow hidden
          text-overflow ellipsis
          white-space nowrap
          font-size 14px
          color #666666
          line-height 70px
          text-align center
          border-right 1px solid #eeeeee
          float left
          width 100px

        & > h2
          font-size 14px
          color #333333
          line-height 40px
          padding-left 10px
          cursor pointer
          transition 300ms
          overflow hidden
          text-overflow ellipsis
          white-space nowrap

          &:hover
            color #000000

          .edit
            color #004a94
            padding 1px
            border-radius 50%
            margin-right 6px
            border 1px solid #004a94

          .verify
            border none
            color #004a94
            font-size 18px
            vertical-align middle

          .reject
            border none
            color #004a94
            font-size 24px
            vertical-align middle

          .inTop
            margin-right 6px
            color #004a94

        & > p
          font-size 14px
          overflow hidden
          color #999999
          padding-left 10px

        .btnlist
          position relative
          top -35px

          li
            display inline-block
            font-size 14px
            color #666666
            border 1px solid #eeeeee
            line-height 30px
            text-align center
            height 30px
            /*width 50px*/
            border-radius 5px
            margin-right 10px
            padding 0 10px
            float right
            user-select none
            cursor pointer
            transition 300ms

            &:hover
              background-color #eeeeee
</style>



// WEBPACK FOOTER //
// src/components/notice/noticeModal.vue